module.exports = __webpack_public_path__ + "static/Dinner-13e482018b73822db135b3d8e53ec1a3.png";